import type { VisitorPageInput } from "@/lib/graphql/generated/types";

/** BE limits of the `pageTitle` / `pagePath` query params of `GET config/:pk/session`. */
export const SESSION_PAGE_TITLE_MAX = 120;
export const SESSION_PAGE_PATH_MAX = 200;

export interface SessionPageParams {
  pageTitle?: string;
  pagePath?: string;
}

/**
 * The host page the session starts on, for the BE to render `{{ page.title }}` / `{{ page.path }}` in the
 * session content. Path only (no query or hash: it can carry tokens), both clamped to the BE limits.
 */
export function sessionPageParams(page: VisitorPageInput | undefined): SessionPageParams {
  if (!page) return {};
  let path: string | undefined;
  try {
    path = new URL(page.url).pathname.slice(0, SESSION_PAGE_PATH_MAX);
  } catch {
    path = undefined;
  }
  const title = page.title?.trim().slice(0, SESSION_PAGE_TITLE_MAX);
  return { ...(title ? { pageTitle: title } : {}), ...(path ? { pagePath: path } : {}) };
}
